import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  overflow-y: auto;
`;
const Modal = styled.div `
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: var(--shadow-2xl);

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 100vh;
  }
`;
const CloseButton = styled.button `
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: background 0.2s;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;
const HeroImage = styled.img `
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
`;
const Content = styled.div `
  padding: 32px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;
const DateLabel = styled.div `
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: var(--text-tertiary);
  margin-bottom: 8px;
`;
const Title = styled.h1 `
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  color: var(--text-primary);
  margin-bottom: 32px;
  line-height: 1.3;
`;
const Section = styled.div `
  margin-bottom: 32px;
`;
const SectionTitle = styled.h2 `
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--accent-gold, #B8860B);
  margin-bottom: 16px;
`;
const SectionContent = styled.div `
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-secondary);
  white-space: pre-wrap;
`;
const CountryBlock = styled.div `
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const CountryHeader = styled.h3 `
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const CountryFlag = styled.span `
  font-size: 20px;
  line-height: 1;

  .fi {
    width: 1.3em;
    height: 1em;
    border-radius: 2px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  }
`;
const CountryText = styled.p `
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-secondary);
  margin: 0;
  padding-left: 32px;
`;
const RapaportDetailModal = ({ comment, onClose }) => {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
    return (_jsx(Overlay, { onClick: handleOverlayClick, children: _jsxs(Modal, { children: [_jsx(CloseButton, { onClick: onClose, children: "\u00D7" }), comment.imageUrl && (_jsx(HeroImage, { src: comment.imageUrl, alt: comment.title })), _jsxs(Content, { children: [_jsx(DateLabel, { children: new window.Date(comment.date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            }) }), _jsx(Title, { children: comment.title }), comment.content.news && (_jsxs(Section, { children: [_jsx(SectionTitle, { children: "News" }), _jsx(SectionContent, { children: comment.content.news })] })), comment.content.fancies && (_jsxs(Section, { children: [_jsx(SectionTitle, { children: "Fancies" }), _jsx(SectionContent, { children: comment.content.fancies })] })), comment.content.countryComments.length > 0 && (_jsxs(Section, { children: [_jsx(SectionTitle, { children: "Country Comments" }), comment.content.countryComments.map((country, idx) => (_jsxs(CountryBlock, { children: [_jsxs(CountryHeader, { children: [_jsx(CountryFlag, { children: country.countryCode
                                                        ? _jsx("span", { className: `fi fi-${country.countryCode}` })
                                                        : country.flag }), country.country] }), _jsx(CountryText, { children: country.text })] }, idx)))] }))] })] }) }));
};
export default RapaportDetailModal;
